import { axiosAzureInstance } from '../Utils/axios';
import type { AxiosResponse } from 'axios';

const API_BASE_URL = '/ihubadapter/api';

interface BulkMigrationRequest {
  file: File;
}

interface DeferredMessageQuery {
  page?: number;
  size?: number;
  sort?: string;
  [key: string]: string | number | boolean | undefined;
}

const IHubAdapterService = {
  migrateServicesInBulk(request: BulkMigrationRequest, size: number): Promise<AxiosResponse> {
    const formData = new FormData();
    formData.append('file', request.file);
    return axiosAzureInstance.post(`${API_BASE_URL}/services/bulk?size=${size}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },

  getCustomers(): Promise<AxiosResponse> {
    return axiosAzureInstance.get(`${API_BASE_URL}/customers`);
  },

  getMigrationHistory(
    customerNumber: string,
    startDate: string | null = null,
    endDate: string | null = null
  ): Promise<AxiosResponse> {
    let url = `${API_BASE_URL}/migration/history?customerNumber=${customerNumber}`;
    if (startDate) url += `&startDate=${startDate}`;
    if (endDate) url += `&endDate=${endDate}`;
    return axiosAzureInstance.get(url);
  },

  getMigrationHistoryDetailed(
    customerNumber: string,
    startDate: string | null = null,
    endDate: string | null = null
  ): Promise<AxiosResponse> {
    let url = `${API_BASE_URL}/migration/history/detailed?customerNumber=${customerNumber}`;
    if (startDate) url += `&startDate=${startDate}`;
    if (endDate) url += `&endDate=${endDate}`;
    return axiosAzureInstance.get(url);
  },

  findDeferredMessages(params: DeferredMessageQuery): Promise<AxiosResponse> {
    return axiosAzureInstance.get(`${API_BASE_URL}/deferred-messages`, { params });
  },
};

export default IHubAdapterService;
